import * as React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';

import {
    closeTabRef,
    LogoComponent,
    getCompanyName,
    CopyToClipboard,
    VerificationService,
    SuccessResponse,
} from '@sheerid/jslib';

import { FaqLinkComponent } from '../../FaqLink/FaqLinkComponent';


interface StepSuccessProps {
    verificationService: VerificationService;
    isCentered?: boolean;
    intl: any;
}

const redirect = (redirectDestination: string) => {
    const win = window.open(redirectDestination, '_parent');
    win.focus();
};

const StepSuccess = ({ verificationService, isCentered, intl }: StepSuccessProps) => {
    // Close any open tab for SSO login
    closeTabRef();

    const hasLogo = verificationService.programTheme.logoUrl ? true : false;
    const redirectDestination: string =
        intl.formatMessage({
            id: 'redirectUrl',
            defaultMessage: 'https://www.nike.com/',
        });

    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}';

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-l-horz-center">
                    { hasLogo ?
                        <LogoComponent verificationService={verificationService} />
                        :
                        <img
                            className="sid-l-lead-image"
                            alt="design element"
                            src="https://assets-resources.sheerid.com/common/images/2018/icons/circle-check.svg"
                        />
                    }
                </div>
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="CONGRATULATIONS!" />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width">
                    <FormattedHTMLMessage id="step.success.subtitle" defaultMessage={
                        "You've been verified. Below is your single-use promo code which can be used during checkout www.nike.com. The promo code cannot be combined with any other offer or promotion."
                    } />
                </div>
            </div>

            <div className="sid-reward-code-text sid-l-space-top-lg sid-h-jumbo-text sid-l-horz-center">
            <FormattedHTMLMessage id="step.success.codeText" defaultMessage="Promo code:" />
            </div>

            <div className="sid-reward-code sid-l-space-top-lg sid-h-jumbo-text sid-l-horz-center">
                {rewardCode}
            </div>
            <div className="sid-header__thanks sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.thanks" defaultMessage="Thank you for your service" />
            </div>
            <div className="sid-l-space-top-md sid-h-bold-text sid-l-horz-center">
                <CopyToClipboard
                    textToCopy={rewardCode}
                >
                    <FormattedHTMLMessage id="step.success.copyCouponCode" defaultMessage="Copy promo code" />
                </CopyToClipboard>
            </div>

            <div className="sid-submit sid-l-space-top-md">
                <button
                    onClick={() => redirect(redirectDestination)}
                    className="sid-btn sid-btn--dark"
                >
                    <FormattedHTMLMessage id="redirectButtonText" defaultMessage="CONTINUE TO NIKE" />
                </button>
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormattedHTMLMessage id="step.success.verificationOnly"
                    defaultMessage={`
                        SheerID handles verification only.
                        Now that you've been approved, please direct all questions about the
                        promotion terms and/or code use to {companyName} customer service.
                    `}
                    values={{
                        companyName: getCompanyName(verificationService.programTheme),
                    }}
                />
            </div>
            <div className={isCentered ? 'sid-footer__powered-by-container--stacked sid-l-horz-center' : 'sid-footer__powered-by-container'}>
            <div className={isCentered ? 'sid-footer__powered-by--stacked sid-l-horz-center' : 'sid-footer__powered-by'}>
                <FormattedHTMLMessage
                    id="poweredBy"
                    defaultMessage="Verification services powered by SheerID."
                />
            </div>
            <div className={isCentered ? 'sid-l-space-top-sm' : ''}>
                &nbsp;<FaqLinkComponent verificationService={verificationService} />
            </div>
            </div>
        </div>
    );
};

export const StepSuccessComponent = injectIntl(StepSuccess);

